import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '@freelancer/directives';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { EmailVerificationBannerModule } from '../../email-verification-banner/email-verification-banner.module';
import { FreelancerVerifiedBadgeModule } from '../../freelancer-verified/freelancer-verified-badge/freelancer-verified-badge.module';
import { UserListsCommonModule } from '../../user-lists/user-lists-common/user-lists-common.module';
import { UserProfilePictureModule } from '../user-profile-picture/user-profile-picture.module';
import { UserProfileSummaryDescriptionComponent } from './user-profile-summary-description/user-profile-summary-description.component';
import { UserProfileSummaryExtraInfoComponent } from './user-profile-summary-extra-info/user-profile-summary-extra-info.component';
import { UserProfileSummaryFeaturedReviewComponent } from './user-profile-summary-featured-review/user-profile-summary-featured-review.component';
import { UserProfileSummaryInformationComponent } from './user-profile-summary-information/user-profile-summary-information.component';
import { UserProfileSummaryNameComponent } from './user-profile-summary-name/user-profile-summary-name.component';
import { UserProfileSummaryOnlineIndicatorComponent } from './user-profile-summary-online-indicator/user-profile-summary-online-indicator.component';
import { UserProfileSummaryRatingComponent } from './user-profile-summary-rating/user-profile-summary-rating.component';
import { UserProfileSummaryReputationItemComponent } from './user-profile-summary-reputation/user-profile-summary-reputation-item/user-profile-summary-reputation-item.component';
import { UserProfileSummaryReputationComponent } from './user-profile-summary-reputation/user-profile-summary-reputation.component';
import { UserProfileSummaryResponsivenessComponent } from './user-profile-summary-responsiveness/user-profile-summary-responsiveness.component';
import { UserProfileSummaryTaglineComponent } from './user-profile-summary-tagline/user-profile-summary-tagline.component';
import { UserProfileSummaryVerificationsComponent } from './user-profile-summary-verifications/user-profile-summary-verifications.component';
import { UserProfileSummaryComponent } from './user-profile-summary.component';

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    EmailVerificationBannerModule,
    FeatureFlagsModule,
    FreelancerVerifiedBadgeModule,
    PipesModule,
    TrackingModule,
    UiModule,
    UserProfilePictureModule,
    UserListsCommonModule,
  ],
  declarations: [
    UserProfileSummaryComponent,
    UserProfileSummaryDescriptionComponent,
    UserProfileSummaryExtraInfoComponent,
    UserProfileSummaryFeaturedReviewComponent,
    UserProfileSummaryInformationComponent,
    UserProfileSummaryNameComponent,
    UserProfileSummaryOnlineIndicatorComponent,
    UserProfileSummaryRatingComponent,
    UserProfileSummaryReputationComponent,
    UserProfileSummaryReputationItemComponent,
    UserProfileSummaryResponsivenessComponent,
    UserProfileSummaryTaglineComponent,
    UserProfileSummaryVerificationsComponent,
  ],
  exports: [UserProfileSummaryComponent],
})
export class UserProfileSummaryModule {}
